import React from 'react';
import { checkValue, appendMcicid } from 'src/components/common/helper';
import { UitkLink } from 'uitk-react-link';
import { UitkBreadcrumbs } from 'uitk-react-breadcrumbs';
import { BreadCrumbProps } from 'src/components/common/module-util';
import gaLogger from 'src/utils/ga-logger';

class BreadCrumb extends React.Component<BreadCrumbProps, any> {
  public constructor(props: any) {
    super(props);
    this.state = {
      showMenu: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick() {
    this.setState({
      showMenu: !this.state.showMenu,
    });
  }

  private onLinkClick = (eventCategory: string, eventAction: string, eventLabel: string, mcicdTrackings?:any) =>{
    let breadcrumbUrl = window.location.host + eventLabel;
    gaLogger.logGa(eventCategory, eventAction, breadcrumbUrl);

    if(checkValue(mcicdTrackings)){
      const {templateType,campaignUrl,referrerId, mainUrl} = mcicdTrackings;
      breadcrumbUrl = appendMcicid(breadcrumbUrl,templateType,campaignUrl,mainUrl,referrerId);

    } 
  }

  public render() {
    const {BreadCrumbs, homeLoc, homeHref, expTracking, middleLayerCopy, middleLayerUrl, isMiddleLayerEnable} = this.props;
    let isShowBreadcrumb = false;
    if (checkValue(BreadCrumbs, true)) {
      isShowBreadcrumb = true;
    }

    let breadcumbLink = '';
    const crumbs = [];

    const getBreadcrumbs = () => {      
      crumbs.push(
        <UitkLink inline={true} size="small">
          <a href={`/${homeHref}`}>{checkValue(homeLoc) ? homeLoc : 'Home'}</a>
        </UitkLink>
      );
      if((checkValue(isMiddleLayerEnable) && isMiddleLayerEnable.toLocaleLowerCase() === "true") && checkValue(middleLayerCopy)){
        crumbs.push(
          <UitkLink inline={true} size="small">
            <a href={`${checkValue(middleLayerUrl)?'/'+ middleLayerUrl:'#'}`}>{middleLayerCopy}</a>
          </UitkLink>
        );
      }

      if (isShowBreadcrumb) {
        BreadCrumbs.map((breadcrumb: any, index) => {
          if (checkValue(breadcrumb.Value)) {
            if (BreadCrumbs.length === index + 1) {
              crumbs.push(
                <>
                  <span key={`crumb-${index}`} aria-hidden="true" className="t-hero-breadcumb-currentpage">
                    {breadcrumb.DisplayName}
                  </span>
                </>
              );
            } else {
              breadcumbLink = breadcumbLink + ('/' + breadcrumb.Value);
              crumbs.push(
                <UitkLink key={`crumb-${index}`} inline={true} size="small">
                  <a
                    href={breadcumbLink}
                    onClick={() => this.onLinkClick('Breadcrumb Link', breadcrumb.DisplayName, breadcumbLink, expTracking)}
                  >
                    {breadcrumb.DisplayName}
                  </a>
                </UitkLink>
              );
            }
          }
        });
      }

      if (crumbs) {
        return (
          <div className="t-hero-breadcumb">
            <UitkBreadcrumbs
              crumbs={crumbs}
              hasDynamicInlineCrumbs={true}
              isOpen={this.state.showMenu}
              onTriggerClick={this.handleClick}
            />
          </div>
        );
      }
    };

    return getBreadcrumbs();
  }
}

export default BreadCrumb;
